import * as t from 'io-ts';

import type { TextInputDefinition } from 'header/types';

import { define, createSpecSettingsInterface } from './_common';

export interface InfoProviderSettingDefinition extends TextInputDefinition {
    key: 'INFO_PROVIDER';
}

const definition: InfoProviderSettingDefinition = {
    key: 'INFO_PROVIDER',
    label: 'Info provider',
    type: 'TextInput',
    value: '',
    scope: 'user',
};

const specSettingsInterface = createSpecSettingsInterface(definition, t.string);

export const codec = specSettingsInterface.input;

export const InfoProviderSettingDefinition = define({
    key: 'INFO_PROVIDER',
    label: 'info provider',
    definition,
    fromSetting: settings => specSettingsInterface.extractValue(settings.infoProvider),
    createDefinitionWithOpts: (opts = {}) => ({ ...definition, ...opts }),
    createDefinitionFromSpec: settings =>
        specSettingsInterface.createDefinitionWithSettings(settings.infoProvider),
});
